import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedserviceService } from 'src/app/services/sharedservice.service';
import { MustMatch } from 'src/app/services/must-match';
import { ToastrManager } from 'ng6-toastr-notifications';
declare var $:any;

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  show: boolean = false;
  regForm: FormGroup;
  selectptype:any='Select Type';
  errors:any;
  success:any;
  matchpasserr:boolean=false;
  hidediv:boolean=false;
  submitted = false;type:any;
  btndisabled:boolean=false;
  constructor(
    private activatedRoute: ActivatedRoute, 
    private fb: FormBuilder, 
    public sharedService: SharedserviceService, 
    public router: Router,
    private toastr: ToastrManager,) {
    
  }

  ngOnInit() {
    this.regForm = this.fb.group({
      role_id:[''],
      name:['', Validators.required],
      email:['', Validators.required],
      mobile:['', [Validators.required, Validators.maxLength(10)]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required,Validators.minLength(6)]],
      company_name:[''],
      pan:[''],
    },{
      validator: MustMatch('password', 'confirmPassword')
    });
    //this.loadType();
  }
  loadType(){
    this.sharedService.get('v1/role_list').subscribe((res) => {
      if (res.replyCode == 'success') {
        this.type = res.data;
      }
    });
  }
  get f() { return this.regForm.controls; }

password() {
    this.show = !this.show;
} 

  regUser(){
    this.submitted = true;
    if (this.regForm.invalid) { 
      return;
    }else{
      this.hidediv=true;
      this.showloader()
      const self=this;
      self.btndisabled= true;
      self.sharedService.loadingShow = true;
      var bodyObject={
        // "role_id":this.regForm.value.role_id,
        "role_id":2,
        "name":this.regForm.value.name,
        "email":this.regForm.value.email,
        "mobile":this.regForm.value.mobile,
        "password":this.regForm.value.password,
        "device_token":"44634w8q7d7edwq6eqw46",
        "device_type":"web",
        "company_name":this.regForm.value.company_name,
        "pan_no":this.regForm.value.pan,
      }
      this.sharedService.post('v1/users/registration',bodyObject).subscribe((res)=> {
        if(res.replyCode == 'success'){
          self.btndisabled= false;
          this.submitted = false;
          this.regForm.reset();
          self.router.navigate(['/auth/login']);
          this.toastr.successToastr(res.replyMsg, 'Success');
        }else{
          self.btndisabled= false; 
          this.hideloader()
          this.hidediv=false;
          this.toastr.errorToastr(res.message, 'Error');
        }
      },err=>{
        self.btndisabled= false; 
        this.hideloader()
        this.hidediv=false;
        if(err['error'].replyMsg[0].message){
          this.toastr.errorToastr(err['error'].replyMsg[0].message, 'Error');
        }else{
          this.toastr.errorToastr(err['error'].replyMsg, 'Error');
        }
        
      });
    }
  }

  numberOnly(event): boolean {
   const charCode = (event.which) ? event.which : event.keyCode;
   if (charCode > 31 && (charCode < 48 || charCode > 57)) {
     return false;
   }
   return true;
   }
   charactoronly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    // allow letters and whitespaces only.
    if(!(charCode >= 65 && charCode <= 122) && (charCode != 32 && charCode != 0)) { 
        return false; 
    }
    return true;
  } 
  matchpassword(){
    if(this.regForm.value.password != this.regForm.value.confirmPassword){
      this.matchpasserr=true;
    }else{ this.matchpasserr=false; }
  }

  hideloader() { 
    document.getElementById('loader').style.display = 'none'; 
  }
  showloader() { 
    document.getElementById('loader').style.display = 'block'; 
  }
}
